module.exports = __webpack_public_path__ + "img/twitter-icon-white.e582dd7f.svg";